import React from "react";
import { Box, Grid, styled, Switch, Typography } from "@mui/material";
import businessWomanImage from "../../resources/images/png/home/businessWoman.png";
import { CenteredSiteBlock } from "../../routes/Home";
import InexSwitch from "../InexSwitch";
import RainbowDivider from "../misc/RainbowDivider";
import SubscribeCard from "./subscribe/SubscribeCard";
import weirdBackground from "../../resources/images/svg/home/weirdBg.svg";
import TestimonialCard from "./subscribe/TestimonialCard";

import { ReactComponent as InexploreLogo } from "../../resources/images/svg/home/subscribe/inexplore.svg";
import trustLabel from "../../resources/images/png/home/subscribe/unequaledLabel.png";
import twentyYears from "../../resources/images/png/home/subscribe/20YearsExperience.png";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    position: "relative",
    // backgroundImage: `url(${businessWomanImage})`,
    // backgroundOpacity: 0.22,
  };
});

const SubscribeNow = () => {
  const [monthly, setMonthly] = React.useState(true);

  return (
    <Container className={"subscribe"}>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "50%",
          background:
            "linear-gradient(180deg, rgba(84, 38, 132, 0) 0%, #0D0034 100%)",
          opacity: 0.5,
        }}
      />
      <CenteredSiteBlock
        sx={{
          background: `url(${weirdBackground})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "top",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            mt: 10,
            mb: 10,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 500,
              margin: 0,
              textAlign: "center",
              color: "white",
            }}
          >
            Abonnez-vous dès maintenant
          </Typography>
          {/*<Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 5,
            }}
          >
            <Typography
              variant="p"
              sx={{
                fontWeight: 500,
                marginRight: 3,
                textAlign: "center",
                color: "white",
                opacity: !monthly ? 0.5 : 1,
                transition: "opacity 0.2s",
              }}
            >
              Paiement mensuel
            </Typography>
            <InexSwitch
              checked={!monthly}
              onChange={() => setMonthly(!monthly)}
              sx={{
                transform: "scale(1.5)",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginLeft: 3,
                opacity: monthly ? 0.5 : 1,
                transition: "opacity 0.2s",
              }}
            >
              <Typography
                variant="p"
                sx={{
                  fontWeight: 500,
                  textAlign: "center",
                  color: "white",
                }}
              >
                Paiement annuel
              </Typography>
              <Typography
                variant="p"
                sx={{
                  textAlign: "center",
                  color: (theme) => theme.palette.yellow,
                  fontSize: "16px",
                }}
              >
                2 mois offerts
              </Typography>
            </Box>
          </Box>*/}

          <Box
            sx={{
              mt: 5,
              marginRight: "5vw",
              marginLeft: "5vw",
            }}
          >
            <SubscribeCard />
          </Box>

          <Box
            sx={{
              mt: 15,
              marginLeft: "5vw",
              marginRight: "5vw",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                width: "100%",
                mb: 3,
              }}
            >
              <Box
                item
                sx={{
                  display: "flex",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  width: { xs: "100%", md: "33.333%" },
                }}
              >
                <InexploreLogo
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  width: { xs: "100%", md: "33.333%" },
                }}
              >
                <img
                  src={trustLabel}
                  alt={"unequaledLabel"}
                  style={{ width: "100%", maxHeight: "150px", objectFit: "contain" }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  width: { xs: "100%", md: "33.333%" },
                }}
              >
                <img
                  src={twentyYears}
                  alt={"unequaledLabel"}
                  style={{ width: "100%", maxHeight: "120px", objectFit: "contain" }}
                />
              </Box>
            </Box>
            <TestimonialCard />
          </Box>
        </Box>
      </CenteredSiteBlock>
      <RainbowDivider
        sx={{
          zIndex: 1,
        }}
      />
    </Container>
  );
};

export default SubscribeNow;
